<template>
  <div class="d-flex-column justify-start align-start gap-40">
    <MmoPackDetail class="small_bg_2" v-if="!$isMobile() && !$isTablet()" />

    <RatingPicker :defaul-value="1800" />
  </div>
</template>

<script setup>
import ServerPicker from "./pickers/ServerPicker.vue";
import RatingPicker from "./pickers/RatingPickerBlitz.vue";
import ExtraOptionPicker from "./pickers/ExtraOptionPicker.vue";
import MmoPackDetail from "./pickers/MmoPackDetail.vue";
import { computed, watch, onMounted } from "vue";

const checkoutStore = useCheckoutStore();
const { getGamePack, getGame } = useGameStore();

const clickSingleOption = (option) => {
  console.log(option.id);
  if (checkoutStore.getPackOptions?.includes(option.id)) {
    return;
  }
  checkoutStore.removePackOption({
    optionIds: option?.rules?.disable || [],
  });
  checkoutStore.setPackOptions({
    options: [...checkoutStore.getPackOptions, option.id],
  });
};

const selectPiloted = () => {
  const pilotedOption = getGamePack?.pack_options?.find(
    (option) => option.const_title === "account_sharing"
  );
  if (pilotedOption) {
    clickSingleOption(pilotedOption);
  }
};

watch(
  () => checkoutStore.getDetails,
  (newVal) => {
    if (newVal.desiredRating > 1800) {
      selectPiloted();
    }
  },
  { deep: true }
);

const handleDetails = () => {
  const account_sharing = getGamePack?.pack_options?.find(
    (op) => op.const_title === "account_sharing"
  );
  const standard = getGamePack?.pack_options?.find(
    (op) => op.const_title === "standard"
  );
  checkoutStore.clearCheckout();
  checkoutStore.setServer(1);
  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setDetails({
    currentRating: 0,
    desiredRating: 1800,
  });
  checkoutStore.setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
  if (account_sharing) {
    checkoutStore.setPackOptions({
      options: [...checkoutStore.getPackOptions, account_sharing.id],
    });
  }
  if (standard) {
    checkoutStore.setPackOptions({
      options: [...checkoutStore.getPackOptions, standard.id],
    });
  }
};

handleDetails();

onMounted(() => {
  checkoutStore.setCalculating();
});
</script>
